import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { getFrasesConfirmacionPlantelThunk } from "../../../store/reducers/frasesConfirmacion/Frasesconfirmacionplantel.thunks";
import {
  clearFrasesConfirmacionPlantelError,
  resetFrasesConfirmacionPlantel,
  setPage,
} from "../../../store/reducers/frasesConfirmacion/Frasesconfirmacionplantel.reducer";

import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import Pagination from "../../UI/Pagination";
import EmptyState from "../../UI/EmptyState";
import FrasesConfirmacionHeaderPlantel from "./Frasesconfirmacionheaderplantel";
import FrasesConfirmacionPlantelTable from "./Frasesconfirmacionplanteltable";
import FraseConfirmacionViewModalPlantel from "./Fraseconfirmacionviewmodalplantel";
import FraseConfirmacionFormModalPlantel from "./Fraseconfirmacionformmodalplantel";
import ConfirmToggleModalFrasePlantel from "./Confirmtogglemodalfraseplantel";

const FrasesConfirmacionListLayerPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();

  const {
    list,
    loading,
    error,
    page,
    pageSize,
    search,
    talentoFilter,
    preguntaFilter,
    count,
  } = useSelector((state) => state.frasesConfirmacionPlantel);

  useEffect(() => {
    if (!plantelId) return;
    dispatch(
      getFrasesConfirmacionPlantelThunk({
        plantelId,
        page,
        search,
        talento: talentoFilter,
        pregunta: preguntaFilter,
      }),
    );
  }, [dispatch, plantelId, page, search, talentoFilter, preguntaFilter]);

  // Limpiar al desmontar para no mezclar datos entre planteles
  useEffect(() => {
    return () => {
      dispatch(resetFrasesConfirmacionPlantel());
    };
  }, [dispatch]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  const hasActiveFilters = search || talentoFilter || preguntaFilter;

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <FrasesConfirmacionHeaderPlantel />

        {/* ERROR */}
        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearFrasesConfirmacionPlantelError())}
          />
        )}

        {/* LOADING */}
        {loading ? (
          <Loader center text="Cargando frases..." delay={200} />
        ) : (
          <>
            {/* INFO DE BÚSQUEDA */}
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {/* EMPTY / TABLE */}
            {list.length === 0 ? (
              <EmptyState
                icon={
                  hasActiveFilters
                    ? "mdi:magnify-remove-outline"
                    : "mdi:format-quote-close"
                }
                title={
                  hasActiveFilters
                    ? "No se encontraron frases"
                    : "No hay frases registradas"
                }
                description={
                  hasActiveFilters
                    ? "Intenta con otra búsqueda o filtros"
                    : "No hay frases disponibles para este plantel"
                }
              />
            ) : (
              <>
                <FrasesConfirmacionPlantelTable frases={list} search={search} />
                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </>
        )}
      </div>

      {/* MODALES */}
      <FraseConfirmacionViewModalPlantel />
      <FraseConfirmacionFormModalPlantel />
      <ConfirmToggleModalFrasePlantel />
    </div>
  );
};

export default FrasesConfirmacionListLayerPlantel;
